export default function getPageViewId() {
  var _window = window,
      nwa = _window.nwa;

  if (nwa) {
    return nwa.getGlobalProp('pageViewId');
  }

  return null;
}